export const quizInputContainerStyles = 'flex flex-col w-full gap-[6px]';

export const quizLabelStyles = 'flex flex-row font-semibold text-base leading-6 tracking-[0%]';

export const quizRequiredIndicatorStyles =
  'text-failure font-semibold text-base leading-6 tracking-[0%]';

// Base styles copied from StandardInputStyles with tweaked disabled colors for quiz-only usage
export const quizBaseInputStyles = `
  bg-input_white 
  text-text_gray_800 
  w-full 
  rounded-lg 
  border 
  border-solid 
  border-border_gray_300 
  px-[14px] 
  py-[10px] 
  gap-[8px] 
  shadow-[0px_1px_2px_0px_#0A0D120D] 
  font-normal 
  text-base 
  leading-6 
  tracking-[0%]
  focus:outline-none
  focus:ring-0
  focus:border-[#D5D7DA]
  focus:bg-input_white
  focus:text-text_gray_800
  disabled:bg-input_white
  disabled:text-text_gray_800
  disabled:cursor-not-allowed
`;

export const quizCompactInputStyles = `
  bg-input_white 
  text-text_gray_800 
  w-full 
  rounded-lg 
  border 
  border-solid 
  border-border_gray_300 
  px-[10px] 
  py-[6px] 
  gap-[6px] 
  shadow-[0px_1px_2px_0px_#0A0D120D] 
  font-normal 
  text-sm 
  leading-5 
  tracking-[0%]
  focus:outline-none
  focus:ring-0
  focus:border-[#D5D7DA]
  focus:bg-input_white
  focus:text-text_gray_800
  disabled:bg-input_white
  disabled:text-text_gray_800
  disabled:cursor-not-allowed
`;

export const quizFixedHeightInputStyles = `${quizBaseInputStyles} h-[44px]`;
export const quizCompactHeightInputStyles = `${quizCompactInputStyles} h-[32px]`;

export interface QuizInputBaseProps {
  id: string;
  label?: string; // allow optional, so we can omit labels locally
  isRequired?: boolean;
  placeholderText?: string;
  value: string | number;
  isLoading?: boolean;
}

export const getQuizInputClassName = (
  prefix: string,
  variant: 'default' | 'compact' = 'default',
) => {
  const heightStyles =
    variant === 'compact' ? quizCompactHeightInputStyles : quizFixedHeightInputStyles;
  switch (prefix) {
    case 'text':
    case 'number':
    case 'select':
      return `quiz-input-${prefix} ${heightStyles}`;
    default:
      return `quiz-input-${prefix} ${
        variant === 'compact' ? quizCompactInputStyles : quizBaseInputStyles
      }`;
  }
};
